/**
 * Market Selector Component
 * Handles country/language selection and remembers user's preference to hide the selector
 */
class MarketSelector extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.countrySelect = this.querySelector('select[name="country_code"]');
    this.localeInput = this.querySelector('input[name="locale_code"]');
    this.closeButton = document.getElementById('close-market-selector');
    this.selectorContainer = document.getElementById('market-selector-container');
    this.popupIdentifier = 'market-selector-closed';
    this.axeptioCrossDomain = ["treasytrees.ca", "treasytrees.com", "bosapin.com"];

    this.bindEvents();
    this.checkCookieState();
  }

  setCookie(name, value, days = 30) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value || ''}${expires}; path=/; SameSite=Lax`;
  }

  getCookie(name) {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const trimmedCookie = cookie.trim();
      if (trimmedCookie.startsWith(`${name}=`)) {
        return trimmedCookie.substring(name.length + 1);
      }
    }
    return null;
  }

  checkCookieState() {
    const cookie = this.getCookie(this.popupIdentifier);

    // Check localStorage as a fallback for Safari
    const localStorageValue = localStorage.getItem(this.popupIdentifier);

    if ((cookie === 'close' || localStorageValue === 'close') && this.selectorContainer) {
      this.hideContainer();
    }
  }

  hideContainer() {
    this.selectorContainer.style.display = 'none';
  }

  bindEvents() {
    if (this.countrySelect) {
      this.countrySelect.addEventListener('change', this.handleCountryChange.bind(this));
    }

    if (this.form) {
      this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.handleClose.bind(this));
    }
  }

  handleCountryChange() {
    const selectedOption = this.countrySelect.options[this.countrySelect.selectedIndex];
    const localeCode = selectedOption.getAttribute('data-locale');
    this.localeInput.value = localeCode;
  }

  handleFormSubmit(event) {
    event.preventDefault();
    // Hide the selector and set cookie when user submits
    if (this.selectorContainer) {
      this.hideContainer();

      // Enhanced cookie setting for Safari
      this.setCookie(this.popupIdentifier, 'close', 30);

      // Force store the cookie state in localStorage as a backup for Safari
      try {
        localStorage.setItem(this.popupIdentifier, 'close');
      } catch (e) {
        console.warn('Could not set localStorage item', e);
      }
    }
    this.form.submit();
  }

  handleClose(event) {
    event.preventDefault();
    if (this.selectorContainer) {
      this.hideContainer();

      // Enhanced cookie setting for Safari
      this.setCookie(this.popupIdentifier, 'close', 30);

      // Force store the cookie state in localStorage as a backup for Safari
      try {
        localStorage.setItem(this.popupIdentifier, 'close');
      } catch (e) {
        console.warn('Could not set localStorage item', e);
      }
    }
    return false;
  }
}

// Strip axeptio token from URL
window._axcb = window._axcb || [];
window._axcb.push(function (sdk) {
  sdk.on('cookies:complete', function(){
    try{
      var u = new URL(location.href);
      if (!u.searchParams.has('axeptio_token')) return;
      u.searchParams.delete('axeptio_token');
      history.replaceState({}, '', u.pathname + (u.search ? '?' + u.searchParams.toString() : '') + (u.hash||''));
    }catch(e){}
  });
});

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  const marketSelector = document.querySelector('market-selector-form');
  if (marketSelector && marketSelector.checkCookieState) {
    marketSelector.checkCookieState();
  }
});

customElements.define('market-selector-form', MarketSelector);